import {useEffect} from 'react';

// import { Link } from 'react-router-dom';
// import PrimarySecondaryDistribution from './PrimarySecondaryDistribution';
// import RecordsManagement from './RecordsManagement';
// import TemperatureControlledAmbient from './TemperatureControlledAmbient';
// import ValueAddedServices from './ValueAddedServices';


const AgriLogisticss = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);   
  
  
  
    return(
        <div>
            <div id='international' className="agri-logistics-image">
                <img src='/agri-logistics/Agri-Logistics-Product-Banner.jpg' alt='' className='w-[100%]'/>
            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[100px]  pb-[100px]">
                <p>
                    TCS Agri Logistics offers bulk handling, storage, transportation and distribution 
                    services for food grains, by means of end-to-end bulk supply chain solutions to private, 
                    non-governmental and governmental organisations for perishable foods.
                </p>
                <p>
                    Companies producing live crops require an altogether different management of logistics operations 
                    than non-perishable goods. It requires expertise and speed, as well as complying with the temperature 
                    and sanitation regulations. Agricultural productions require spoilage prevention and a strict track 
                    of quality. TCS with one of the best tracking, tracing and quality control infrastructure provides 
                    all essential services.
                </p>
                <p>
                    TCS, with its team of trained professionals, also provides services for shipping farm equipment 
                    which present unique logistical challenges with special transportation and experience requirements.
                </p>
                
                
                
                 
            </div>
            
            
            

            

        </div>
    )
};
export default AgriLogisticss;